module.exports = __webpack_public_path__ + "static/media/background.2ef9a0bf.jpg";